export default "__VITE_ASSET__DUq1PUPC__"